import { useState } from "react";
import classes from "./ToggleSwitch.module.css";
export default function ToggleSwitch({ label, onChangeHandler }) {
  let isStaffRatingEnabled = JSON.parse(
    localStorage.getItem("questions")
  ).staffRatingEnabled;

  // below state is to track toggle positions
  const [isEnabled, setIsEnabled] = useState(isStaffRatingEnabled);

  console.log(isStaffRatingEnabled);
  function toggleHandler(e) {
    if (window.confirm("Are you sure to change the rating status.") == true) {
      console.log("confired.");
      setIsEnabled((prev) => !prev);
      onChangeHandler(e.target.checked);
    } else {
      console.log("op denied");
    }
  }
  return (
    <div className={classes.container}>
      {label}{" "}
      <div className={classes.toggleSwitch}>
        <input
          type="checkbox"
          className={classes.checkbox}
          name={label}
          id={label}
          checked={isEnabled}
          onChange={(e) => {
            toggleHandler(e);
          }}
        />
        <label className={classes.label} htmlFor={label}>
          <span className={classes.inner} />
          <span className={classes.switch} />
        </label>
      </div>
    </div>
  );
}
